import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const dealernameEmpty = (control: FormControl) => {
    if (!control.value || control.value.length === 0) {
        return { dealernameEmpty: messages.validation.dealerNameEmpty };
    }
};
